const sections= [
    {
        title: 'Sobre nós',
        paragraph: 'Constituída desde 2020, a Frazatto Logística conta com profissionais que atuam no mercado a mais de 10 anos, com foco no transporte de algodão em pluma, prestando serviços administrativos, comerciais e de gestão aos seus clientes, tendo uma operação dedicada e transparente, com soluções integradas sob medida para o carregamento de commodities agrícolas, sempre analisando as necessidades apresentadas por seus clientes.',
        list: [{key: '', value: 'Com uma rede de parceiros que se estende por todo Brasil, garantimos operações eficientes e seguras para a sua carga.'}],
        image: require('@/assets/page/about/about.jpg')
    },
    {
        title: 'Missão',
        paragraph: 'Garantir a movimentação segura e eficaz de cargas agrícolas, otimizando a cadeia logística e gerando valor para nossos clientes e parceiros, através de um serviço ético e transparente.',
        list: [{key: '', value: 'Nosso compromisso é garantir que o valor do seu esforço chegue ao destino com a máxima eficiência.'}],
        image: require('@/assets/page/about/mission.jpg')
    },
    {
        title: 'Visão',
        paragraph: 'Ser referência no mercado de logística e commodities agrícolas, reconhecida pela excelência operacional e contribuindo para o desenvolvimento do agronegócio brasileiro, com base em nossos valores e na confiança de nossos clientes.',
        list: [{key: '', value: 'Seremos a ponte estratégica que impulsiona o agronegócio, conectando o campo ao mercado.'}],
        image: require('@/assets/page/about/vision.jpg')
    },
    {
        title: 'Valores',
        paragraph: '',
        list: [
            {
                key: 'excelência: ',
                value: 'Entregar serviços de alto padrão, garantindo a satisfação dos clientes.'
            },
            {
                key: 'transparência: ',
                value: 'Priorizar clareza e confiança em todas as operações.'
            },
            {
                key: 'inovação: ',
                value: 'Buscar constantemente novas soluções e tecnologias.'
            },
            {
                key: 'compromisso: ',
                value: 'Conectar fronteiras com responsabilidade e ética.'
            },
            {
                key: 'fé: ',
                value: 'Confiar em Deus para nos guiar, afim de sermos um canal de prosperidade aos nossos clientes.'
            },
        ],
        image: require('@/assets/page/about/values.jpg')
    },
]

export default sections;